<template>
    <div id="newTourTab">
        <div class="scroll-list new-tour-sidebar">
            <div class="fields-wrap">
                <form>
                    <div class="line-item">
                        <md-field md-no-float name="tourName">
                            <md-input v-model="newTourName" placeholder="Tour Name" class="ng-pristine ng-valid md-input ng-empty ng-touched" name="tourName" @blur="nameFieldTouchHandler()"></md-input>
                        </md-field>
                        <span class="new-tour-error" v-if="$v.newTourName.$error">The tour name is required.</span>
                    </div>
                    <div class="line-item">
                        <md-field md-no-float name="tourDesc">
                            <md-input v-model="newTourDescription" placeholder="Tour Description" class="ng-pristine ng-valid md-input ng-empty ng-touched" name="tourDesc" @blur="descFieldTouchHandler()"></md-input>
                        </md-field>
                        <span class="new-tour-error" v-if="$v.newTourDescription.$error">The tour description is required.</span>
                    </div>
                    <div class="line-item">
                        <div class='md-field tourLocation'>
                            <GmapAutocomplete placeholder="Tour Location" class="ng-pristine ng-valid md-input ng-empty ng-touched" @place_changed="getSelectedLocation"></GmapAutocomplete>
                        </div>
                        <span class="selected-tour-text" v-if="newTourLocation.id">Selected Location: {{ newTourLocation.formatted_address }}</span>
                    </div>
                </form>
            </div>
        </div>
        <footer v-if="!$v.$invalid" class="aside-btn">
            <md-button class="md-raised md-primary" @click="createNewTour">Create</md-button>
        </footer>
    </div>
</template>
<script>
import * as EditorServices from '../../services/EditorService.js';
import {mapGetters, mapActions} from 'vuex';
import {required} from 'vuelidate/lib/validators';

export default {
  data: () => ({
    newTourName: '',
    newTourDescription: '',
    newTourLocation: {}
  }),
  computed: {
    ...mapGetters('tours', ['currentTour', 'currentTourImage'])
  },
  methods: {
    ...mapActions('tours', ['loadTourEditor']),
    getSelectedLocation (place) {
      this.newTourLocation = place;
      var newCenter = {latLng: {lat: place.geometry.location.lat(), lng: place.geometry.location.lng()}};
      this.$store.dispatch('map/setCenter', newCenter);
      this.error = {state: false, message: ''};
    },
    getImageSrc (image) {
      if (image) {
        if (image.substring(0, 5) !== 'https') {
          return 'static/img/dev/' + image;
        } else {
          return image;
        }
      } else {
        return 'static/img/dev/default-tour.png';
      }
    },
    nameFieldTouchHandler () {
      if (!this.$v.newTourName.$dirty) {
        this.$v.newTourName.$touch();
      }
    },
    descFieldTouchHandler () {
      if (!this.$v.newTourDescription.$dirty) {
        this.$v.newTourDescription.$touch();
      }
    },
    async createNewTour () {
      var newTour = this.currentTour;
      var newTourImage = this.currentTourImage;
      this.error = {state: false, message: ''};
      newTour.name = this.newTourName;
      newTour.description = this.newTourDescription;
      newTour.city = this.newTourLocation.name;
      newTour.image = newTourImage;
      if (this.newTourLocation.photos) {
        newTour.card = this.newTourLocation.photos[0].getUrl({'maxWidth': 1500, 'maxHeight': 1500}).replace('w100-h100-k', 'k');
      } else {
        newTour.card = 'Cortex_Image_Placeholder.png';
      }
      newTour.latLng = {lat: this.newTourLocation.geometry.location.lat(), lng: this.newTourLocation.geometry.location.lng()};
      var response = await EditorServices.newTour(newTour);
      if (response.data.success === true) {
        newTour.id = response.data.tour.id;
        newTour.card = response.data.tour.card;
        this.loadTourEditor(newTour);
        this.$router.push('/tour');
      }
    }
  },
  validations: {
    newTourName: {
      required
    },
    newTourDescription: {
      required
    },
    newTourLocation: {
      required
    }
  },
  mounted () {
    this.$store.dispatch('map/setCenter', {latLng: {lat: 40.4802649, lng: -111.9143293}});
  }
};
</script>
<style lang="scss">
.error-text {
    color: red;
}

#newTourTab .md-input {
    width: 100%;
    font-size: 13px !important;
    border-bottom: 1px solid #696969;
}

#newTourTab ::-webkit-input-placeholder {
    font-size: 13px !important;
}

#newTourTab .fields-wrap {
    height: 100%;
}

#newTourTab .scroll-list {
    position: absolute;
    top: 190px;
    bottom: 50px;
    left: 0;
    right: 0;
}

#newTourTab .sidebar.scroll-list {
    overflow-y: hidden;
}

#newTourTab .selected-tour-text {
    font-size: 11px;
    color: #a8a8a8;
}

#newTourTab .new-tour-error {
    font-size: 11px;
    color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/tour/newTour.vue